import { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
// import * as Sentry from '@sentry/react';

class SilalRequestInterceptors {
  onResponse(response: InternalAxiosRequestConfig<any>) {
    // Do something with response data

    // Replaced with pretty logger interceptor
    // console.log(`RESPONSE[${response.status}] => PATH: ${response.config.url}`);

    return response; // continue
    // If you want to reject the request with an error message,
    // you can throw a custom error object or handle it accordingly.
    // For example:
    // throw new Error('Request rejected');
  }

  onError(error: AxiosError) {
    // Do something with response error

    if (process.env.NODE_ENV === 'development') {
      console.error(
        `onErrorRequestInterceptor[${error.response?.status}] => PATH: ${error}`,
      );
    }

    // if (error?.status === 400 || error?.response?.status === 400) {
    //   Sentry.withScope((scope) => {
    //     scope.setExtra('error', error.response?.data);
    //     scope.addBreadcrumb(
    //       {
    //         category: 'json',
    //         message: 'Form Error 400',
    //         data: {
    //           ...error.response!.data!,
    //         },
    //         level: 'error',
    //       },
    //       50,
    //     );
    //     Sentry.captureException(error);
    //   });
    // }

    return Promise.reject(error);
    // If you want to resolve the request with some custom data,
    // you can modify the error object or handle it accordingly.
    // For example:
    // error.customData = { message: 'Custom error data' };
    // return Promise.resolve(error);
  }
}

class SilalResponseInterceptors {
  onResponse(response: AxiosResponse<any, any>) {
    // Do something with response data

    // Replaced with pretty logger interceptor
    // console.log(`RESPONSE[${response.status}] => PATH: ${response.config.url}`);

    return response; // continue
    // If you want to reject the request with an error message,
    // you can throw a custom error object or handle it accordingly.
    // For example:
    // throw new Error('Request rejected');
  }

  onError(error: AxiosError) {
    // Do something with response error
    if (process.env.NODE_ENV === 'development') {
      console.error(
        `onErrorResponsetInterceptor[${error.response?.status}] => PATH: ${error}`,
      );
    }

    // if (error?.status === 400 || error?.response?.status === 400) {
    //   Sentry.withScope((scope) => {
    //     scope.setExtra('error', error.response?.data);
    //     scope.addBreadcrumb(
    //       {
    //         category: 'json',
    //         message: 'Form Error 400',
    //         data: {
    //           ...error.response!.data!,
    //         },
    //         level: 'error',
    //       },
    //       50,
    //     );
    //     Sentry.captureException(error);
    //   });
    // }

    return Promise.reject(error);
    // If you want to resolve the request with some custom data,
    // you can modify the error object or handle it accordingly.
    // For example:
    // error.customData = { message: 'Custom error data' };
    // return Promise.resolve(error);
  }
}

export { SilalRequestInterceptors, SilalResponseInterceptors };
